<ul class="filter-list">
	@for (item of items; track item) {
		<li>
			<label>
				<input type="checkbox" [checked]="isSelected(item)" (change)="selectItem(item)" />
				<ng-template
					[ngTemplateOutlet]="itemTemplate"
					[ngTemplateOutletContext]="{ $implicit: item, selected: isSelected(item) }"
				/>
			</label>
		</li>
	}
</ul>
